
import { Member } from '@/models/member';
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { SchemeNodeModel } from '@/models/schemeNodeModel';
import { GroupSchemeScope } from '@/components/mixins/schemescope';

@Component
export default class ManualPassModal extends mixins(GroupSchemeScope) {
  @Prop() private members!: Array<Member>;
  @Prop() private level!: SchemeNodeModel;

  async passLevelForMember(member: Member, level: SchemeNodeModel) {
    if (await this.passLevel(member, level)) {
      this.$alert('success', this.$t('scheme.level_passed'));
    } else {
      this.$alert('error', this.$t('global.failed_to_save'));
    }

    if (this.members.length < 1) {
      this.$emit('close'); // all passed
    }
  }
}
